export const sendNotification = (payload: any) => ({
    type: "@saga/SEND_NOTIFICATION",
    payload
});
